import NoCookiesPlaceholder from "../components/NoCookiesPlaceholder.js"
import { BASE_ASSETS_URL } from "../utils/constants.js"

const ArrivalPage = ({ text, settings, setSettings }) => {
    // TODO: trim image for entrance
    return (
        <div className="drocker-body">
            <div className="position-relative">
                <div className="drocker-responsive-image" style={{ backgroundImage: `url(${BASE_ASSETS_URL}images/drockerhof_entrance_2.jpg)` }}></div>
                <div className="container drocker-h1-container">
                    <h1 className="text-white mb-0 drocker-title-outline">{text.arrivalTitle}</h1>
                </div>
            </div>
            <div className="container pt-5">
                <div>
                    <h2>{text.arrivalSubtitle}</h2>
                    <ul className="list-group list-group-flush list-group-numbered mb-3">
                        <li className="list-group-item">{text.arrivalDirections1}</li>
                        <li className="list-group-item">{text.arrivalDirections2}</li>
                        <li className="list-group-item">{text.arrivalDirections3}</li>
                        <li className="list-group-item">{text.arrivalDirections4}</li>
                        <li className="list-group-item">{text.arrivalDirections5}</li>
                        <li className="list-group-item">{text.arrivalDirections6}</li>
                        <li className="list-group-item">{text.arrivalDirections7}</li>
                    </ul>
                </div>
                <div>
                    <h3>{text.arrivalFullAddress}</h3>
                    <p dangerouslySetInnerHTML={{ __html: text.arrivalAddress }} />
                </div>
                <div>
                    <h5>{text.arrivalFindUsOnGoogleMaps}</h5>
                    {(settings.acceptOnlyNecessaryCookies === false)
                        ? <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d175809.52695780652!2d11.316188838653034!3d46.48783999401388!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47780e2ddbee4f7f%3A0xa142d339770b0584!2sDrockerhof!5e0!3m2!1sde!2sit!4v1708891723718!5m2!1sde!2sit" style={{ border: 0, width: "100%", maxHeight: "600px", minHeight: "400px" }} allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="drocker-google-maps" />
                        : <NoCookiesPlaceholder
                            width="100%"
                            maxHeight="600px"
                            minHeight="400px"
                            text={text}
                            placeholderText={text.arrivalMapsDisabled}
                            settings={settings}
                            setSettings={setSettings}
                            showAcceptAllCookies={true}
                        />
                    }
                </div>
            </div>
        </div>
    )
}

export default ArrivalPage
